import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import { canViewMasterFulfillment } from "@saleor/utils/handlers/userHandler";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  StoreOrderListUrlQueryParams,
  StoreOrderListUrlSortField,
  StoreOrderUrlQueryParams
} from "./urls";
import StoreOrderDetailsComponent from "./views/StoreOrderDetails";
import StoreOrderListComponent from "./views/StoreOrderList";

const StoreOrderList: React.FC = () => {
  const location = useLocation();
  const user = useUser();
  const enableViewMasterFulfillment = canViewMasterFulfillment();
  const isOpsAdminView =
    user.user?.userType.code === SmopUserTypeCode.OMI_OPS ||
    enableViewMasterFulfillment;
  const qs = parseQs(location.search.substring(1));
  const params = asSortParams(
    qs,
    StoreOrderListUrlSortField,
    StoreOrderListUrlSortField.date,
    !isOpsAdminView
  ) as StoreOrderListUrlQueryParams;

  return <StoreOrderListComponent params={params} />;
};

const StoreOrderDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<StoreOrderUrlQueryParams>(
    location.search.substring(1)
  );

  return (
    <StoreOrderDetailsComponent id={decodeURIComponent(id)} params={params} />
  );
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.orders)} />
      <Routes>
        <Route path={""} element={<StoreOrderList />} />
        <Route path={":id"} element={<StoreOrderDetails />} />
      </Routes>
    </>
  );
};

export default Component;
